// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!/schools/node_modules/css-loader/index.js!/schools/node_modules/sass-loader/index.js!/schools/node_modules/lightgallery/src/sass/lightgallery.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!/schools/node_modules/style-loader/addStyles.js")(content, {});
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	module.hot.accept("!!/schools/node_modules/css-loader/index.js!/schools/node_modules/sass-loader/index.js!/schools/node_modules/lightgallery/src/sass/lightgallery.scss", function() {
		var newContent = require("!!/schools/node_modules/css-loader/index.js!/schools/node_modules/sass-loader/index.js!/schools/node_modules/lightgallery/src/sass/lightgallery.scss");
		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
		update(newContent);
	});
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ../~/style-loader!../~/css-loader!../~/sass-loader!../~/lightgallery/src/sass/lightgallery.scss
// module id = 1161
// module chunks = 65